"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueGroupItemByIndex = exports.getValueGroupByIndex = void 0;
const value_index_1 = require("./value-index");
/**
 * Retrieve a {@link CostSummaryGroupIndex} or {@link CostElementReferenceGroupIndex} from the given {@link haystack}.
 */
const getValueGroupByIndex = (haystack, index) => {
    return haystack.find((group) => {
        return group.index === index;
    });
};
exports.getValueGroupByIndex = getValueGroupByIndex;
/**
 * Retrieve a {@link CostSummaryGroupItemIndex} or {@link CostElementReferenceGroupItemIndex} from the given {@link haystack}.
 */
const getValueGroupItemByIndex = (haystack, index) => {
    const parsed = (0, value_index_1.parseValueGroupItemIndex)(index);
    const group = (0, exports.getValueGroupByIndex)(haystack, parsed.group);
    if (group === undefined) {
        return group;
    }
    return group.items.find((item) => {
        return item.index === index;
    });
};
exports.getValueGroupItemByIndex = getValueGroupItemByIndex;
